import { useApi } from '../composables'
import http from '../composables/src/useHttp'

export const getNotifications = (unreadOnly = false) => {
  const params = unreadOnly ? { unreadOnly: 'true' } : {}

  return useApi(http.get('/notifications', { params }))
}

export const markNotificationAsRead = (id: string) => {
  return useApi(http.patch(`/notifications/${id}/read`))
}

export const markAllNotificationsAsRead = () => {
  return useApi(http.patch('/notifications/mark-as-read', {}))
}

export const getNotificationPreferences = () => {
  return useApi(http.get('/notifications/preferences'))
}

export const updateNotificationPreferences = (data: any) => {
  return useApi(http.patch('/notifications/preferences', data))
}
